import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { ProtectedRoute } from '@/components/shared/ProtectedRoute'
import Login from '@/pages/Login'
import PurchaseOrders from '@/pages/PurchaseOrders'
import Dashboard from '@/pages/Dashboard'
import ProductType from '@/pages/ProductType'
import Vendors from '@/pages/Vendors'
import Catalog from '@/pages/Catalog'
import Admin from '@/pages/Admin'
import Marketing from '@/pages/Marketing'
import ProductRequests from '@/pages/ProductRequests'
import Receiving from '@/pages/Receiving'
import Stocktakes from '@/pages/Stocktakes'
import StocktakeSession from '@/pages/StocktakeSession'
import Adjustments from '@/pages/Adjustments'
import AdjustmentDetail from '@/pages/AdjustmentDetail'
import EventsAnalysis from '@/pages/EventsAnalysis'
import EventsAdmin from '@/pages/EventsAdmin'
import EventsLive from '@/pages/EventsLive'
import EventsPackList from '@/pages/EventsPackList'
import EventsIntelligence from '@/pages/EventsIntelligence'

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/purchase-orders" replace />} />
        <Route
          path="/purchase-orders"
          element={
            <ProtectedRoute>
              <PurchaseOrders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory/product-type"
          element={
            <ProtectedRoute>
              <ProductType />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendors"
          element={
            <ProtectedRoute>
              <Vendors />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalog"
          element={
            <ProtectedRoute>
              <Catalog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/marketing"
          element={
            <ProtectedRoute>
              <Marketing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <EventsAnalysis />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/pack-list"
          element={
            <ProtectedRoute>
              <EventsPackList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/intelligence"
          element={
            <ProtectedRoute>
              <EventsIntelligence />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/live"
          element={
            <ProtectedRoute>
              <EventsLive />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/admin"
          element={
            <ProtectedRoute requireRole="admin">
              <EventsAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product-requests"
          element={
            <ProtectedRoute>
              <ProductRequests />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireRole="admin">
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-orders/:poId/receive"
          element={
            <ProtectedRoute>
              <Receiving />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stocktakes"
          element={
            <ProtectedRoute>
              <Stocktakes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stocktakes/:sessionId"
          element={
            <ProtectedRoute>
              <StocktakeSession />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adjustments"
          element={
            <ProtectedRoute>
              <Adjustments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adjustments/:adjustmentId"
          element={
            <ProtectedRoute>
              <AdjustmentDetail />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/purchase-orders" replace />} />
      </Routes>
      <Toaster position="top-right" />
    </>
  )
}
